// extracted by mini-css-extract-plugin
module.exports = {"linkStyle":"style_linkStyle__eQzOn"};